// extracted by mini-css-extract-plugin
export var measureBox = "_18-0";